import { Injectable } from '@angular/core';
import { RestApiService } from '../rest-api/rest-api.service';
import { SiteConfiguration } from 'models/site-configuration';
import { BehaviorSubject, Observable } from 'rxjs';
import { Course } from '../../../../../models/course';
import { environment as env } from '../../../../../src/environments/environment';
import { ConfigurationService } from '../configuration/configuration.service';
import { SearchReasults } from 'models/searchResults';
import { CoursesService } from '../courses/courses.services';
import { PortalConfigurationService } from '../portal-configuration/portal-configuration.service';
import { SearchReasult } from 'models/searchResult';

@Injectable({
    providedIn: 'root'
})
export class SearchService {
    public courses: Observable<Course[]>;
    public course: Observable<Course[]>;
    public categories: Observable<Course[]>;
    public lang: SiteConfiguration;
    private _$currentCoursesSubject: BehaviorSubject<Course[]>;
    private _$coursesCount: BehaviorSubject<number> = new BehaviorSubject(0);

    public get coursesCount$(): Observable<{}> {
        return this._$coursesCount.asObservable();
    }

    searchResults: SearchReasults = {
        numberOfPages: 0,
        courses: [],
        totalItems: 0
    };

    searchResult: SearchReasult = {
        image: null,
        name: null,
        description: null,
        link: null
    };

    constructor(
        private _restApiService: RestApiService,
        private config: ConfigurationService,
        private _coursesService: CoursesService,
        private _portalConfigurationService: PortalConfigurationService
    ) {
        this._$currentCoursesSubject = new BehaviorSubject<Course[]>(JSON.parse(localStorage.getItem('courses')));
        this.courses = this._$currentCoursesSubject.asObservable();
    }

    public getCoursesPerPage(searchTerms: any, currentPage: number, itemsPerPage: number) {
        this.lang = this.config.getSiteFromUrl();
        const _language = this.lang ? this.lang.site : 'en_uk';

        const isPortal = this.config.isPartnerPage();
        const currentPortal = this.config.portalId;
        let site = this.config.getSiteFromUrl();
        if (site) {
            site = this.config.getSiteFromUrl().site;
        }
        const _site = isPortal ? currentPortal : site;
        let results = null;

        //return this.searchArray(results, searchTerms, currentPage, itemsPerPage);
    }

    public getCourses() {
        this._coursesService.getAllCourses().then(
            (courses) => {
                return courses;
            },
            (error) => {
                console.log(error);
            }
        );
    }

    private _getPortalCourses(portal: string): Promise<any> {
        const _portal = this._portalConfigurationService.getPortalIdWithUnderscore(portal);

        return this._coursesService.getAllPortalCourses(_portal).then(
            (courses) => {
                return courses;
            },
            (error) => {
                console.log(error);
            }
        );
    }
}
